export default function ComponentsPage() {
    return (
        <div className="contentDiv">
            <h1>Components page</h1>
            <p>
                lorem ipsum
            </p>
        </div>
    );
}
